import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import UserService from '../../services/userService';
import { showMsg } from '../../services/library';
import TeamService from '../../services/teamService';
import DealerService from '../../services/dealerService';

const REQ_ACCOUNT = 'photographerAccounts/';

export const fetchPhotographerUsersReq = createAsyncThunk(
  `${REQ_ACCOUNT}fetchPhotographerUsersReq`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await UserService.getPhotographerUsers();
      if (response?.status) {
        return response.data;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);
export const fetchAddTeam = createAsyncThunk(
  `${REQ_ACCOUNT}fetchAddTeam`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await UserService.addTeam(payload);
      if (response?.status) {
        showMsg(response.message, 'success');
        return { ...payload, ...response };
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

export const fetchEditTeam = createAsyncThunk(
  `${REQ_ACCOUNT}fetchEditTeam`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await TeamService.editTeamProfile(payload);
      if (response?.status) {
        showMsg(response.message, 'success');
        return { ...payload, ...response };
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

export const fetchProfile = createAsyncThunk(
  `${REQ_ACCOUNT}fetchProfile`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await DealerService.getProfile(payload);
      if (response?.status) {
        // showMsg(response.message, 'success');
        return response.data;
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error, 'error');
      return rejectWithValue(error);
    }
  }
);

const photographerAccountsSlice = createSlice({
  name: 'photographerAccounts',
  initialState: {
    userList: [],
    tableLoaded: true,
    accountFilterData: [],
    teamToggle: false,
    editTeamToggle: false,
    teamIdForEdit: ''
  },
  reducers: {
    setUserList: {
      reducer(state, action) {
        state.userList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    setPhotographerToggle: {
      reducer(state, action) {
        state.teamToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    setEditTeamToggle: {
      reducer(state, action) {
        state.editTeamToggle = action.payload;
      }
    },
    setTeamIdForEdit: {
      reducer(state, action) {
        state.teamIdForEdit = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchPhotographerUsersReq.pending, state => {
        state.userList = [];
        state.tableLoaded = true;
      })
      .addCase(fetchPhotographerUsersReq.fulfilled, (state, action) => {
        const data = action.payload;

        state.userList = data;
        state.tableLoaded = false;
      })
      .addCase(fetchPhotographerUsersReq.rejected, state => {
        state.tableLoaded = false;
      })
      .addCase(fetchProfile.pending, state => {
        state.dealerProfileData = {};
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        const data = action.payload;
        state.dealerProfileData = data?.[0]?.dealer || {};
        state.editProfileToggle = !state.editProfileToggle;
      });
  }
});
export const { setUserList, setPhotographerToggle, setTeamIdForEdit, setEditTeamToggle } =
  photographerAccountsSlice.actions;
export default photographerAccountsSlice.reducer;
